import { patchRequest } from '@/core';
import { references } from '@/requests';

export default async function updateReferenceRequest(id, patch) {
	let url = references.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}